import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader';
import { Observable, Subscription } from 'rxjs';
import { AdjustDisplayType } from './modules/shared-state/shared.actions';
import { SharedState } from './modules/shared-state/shared.state';
import { CreateGridReferenceUUIDs, OnSetOnRowDataChanged } from './modules/shared/ag-grid/shared-grid-state/shared-grid.actions';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, NgxUiLoaderModule]
})
export class AppComponent implements OnInit, OnDestroy {

    private _store = inject(Store);
    private _toastrService = inject(ToastrService);
    private _titleService = inject(Title);
    private _showToastrAlert$ = this._store.select(SharedState.getShowToastrAlert);
    private _showLoader$: Observable<boolean> = this._store.select(SharedState.getShowLoader);
    private _showToastrSub: Subscription = new Subscription;
    private _loaderSub: Subscription = new Subscription;
    private _ngxService = inject(NgxUiLoaderService);

    constructor() {
        this._titleService.setTitle(environment.siteName);
    }

    ngOnInit() {
        //** Create the grid reference UUIDs when the app is initialized */
        this._store.dispatch(new CreateGridReferenceUUIDs());
        this._store.dispatch(new AdjustDisplayType(window.innerWidth));
        this._store.dispatch(new OnSetOnRowDataChanged({ changed: false, gridUUID: '' }));

        this._loaderSub = this._showLoader$.subscribe((showLoader) => {
            if (showLoader) {
                this._ngxService.start();
            } else {
                this._ngxService.stop();
            }
        });


        this._showToastrSub = this._showToastrAlert$.subscribe((result: any) => {
            if (result && result.showToast) {
                switch (result.toastrType) {
                    case ('error'):
                        return this._toastrService.error(`${result.messageBody}`, `${result.messageTitle}`, { positionClass: result.position, timeOut: 3000, });
                    case ('success'):
                        return this._toastrService.success(`${result.messageBody}`, `${result.messageTitle}`, { positionClass: result.position, timeOut: 3000, });
                    case ('warning'):
                        return this._toastrService.warning(`${result.messageBody}`, `${result.messageTitle}`, { positionClass: result.position, timeOut: 3000, });
                    case ('info'):
                        return this._toastrService.info(`${result.messageBody}`, `${result.messageTitle}`, { positionClass: result.position, timeOut: 3000, });
                }
            }

        });
    }

    ngOnDestroy(): void {
        this._loaderSub.unsubscribe();
        this._showToastrSub.unsubscribe();
    }


}
